import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

export const Route = createFileRoute(
  "/_staff/ids/_layout/_placeholders/group-id",
)({
  component: () => <ComingSoonCover />,
});
